// types
import { filterStateSchema } from "../types/filterTypes";

export const getFilterState = (state: filterStateSchema) => state.filter;
